import axios from 'axios';

async function ObtenerEspecialidades(prm_Activas: string = '', prm_IdEspecialidad: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_especialidades"
    
    const dataEnvio: { usuario: string; clave: string; activas?: string; id_especialidad?: number; } = {
        "usuario": "mpatti",
        "clave": "all2GetHer_!"
    };

    if (prm_Activas !== '') {
        dataEnvio['activas'] = prm_Activas;
    }

    if (prm_IdEspecialidad !== 0) {
        dataEnvio['id_especialidad'] = prm_IdEspecialidad;
    }
    
    try {
        const response = await axios.post(url, dataEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerEspecialidades;